<app-traitement-data-o2-repos [patient]="patient!" />
<app-traitement-data-o2-effort [patient]="patient!" />
<app-traitement-data-duree [patient]="patient!" />
<app-traitement-data-arret-tabac [patient]="patient!" />
<app-traitement-data-obs [patient]="patient!" />
<app-traitement-data-spo2-sans-o2 [patient]="patient!" />
<app-traitement-data-spo2-avec-o2 [patient]="patient!" />
<app-traitement-data-deamb [patient]="patient!" />